export default {
  sm: `
    THE BEGINNING 
    OF AN ECO-
    FRIENDLY 
    DATA CENTER
  `,
  md: `
    THE BEGINNING OF AN 
    ECO-FRIENDLY DATA CENTER
  `,
  lg: `
    THE BEGINNING OF 
    AN ECO-FRIENDLY 
    DATA CENTER
  `,
  xxl: `
    THE BEGINNING 
    OF AN ECO-FRIENDLY 
    DATA CENTER
  `
};
